import { Link } from '@/components/Link';
import type { RawCatalogEntry } from '../../lib/catalogMap';
import { endpointIdOf, platformIdOf } from '../../lib/catalogPlatform';

/** One endpoint a seller serves, by its public catalog name and page. A SKU the
 *  catalog is not listing right now keeps its id, unlinked, so the seller's
 *  list stays complete. */
const SellerApi = ({ sku, entry }: { sku: string; entry?: RawCatalogEntry }) =>
  entry ? (
    <Link to={`/api/${platformIdOf(sku)}/${endpointIdOf(sku)}`}>{entry.name}</Link>
  ) : (
    <span className="font-mono text-14">{sku}</span>
  );

/** The endpoints a seller serves, each linking to its API page. */
export const SellerApis = ({ skus, catalog }: { skus: string[]; catalog: RawCatalogEntry[] }) => {
  const bySlug = new Map(catalog.map((entry) => [entry.slug, entry]));
  return (
    <ul className="flex flex-wrap gap-x-4 gap-y-1.5 text-15 text-text-2 [&_a]:text-accent [&_a]:underline [&_a]:underline-offset-2">
      {skus.map((sku) => (
        <li key={sku}>
          <SellerApi sku={sku} entry={bySlug.get(sku)} />
        </li>
      ))}
    </ul>
  );
};
